'use client';

import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom"; // If you're using React Router
import { Ghost } from "lucide-react";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground p-6">
      <div className="text-center space-y-6">
        <Ghost className="mx-auto h-16 w-16 text-muted-foreground" />
        <h1 className="text-4xl font-bold">404 - Page Not Found</h1>
        <p className="text-muted-foreground text-lg">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <Button onClick={() => navigate('/dashboard')} className="mt-4">
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
}
